
import Vue from "vue"
import Message from '@/components/messageArea/index.vue'
import { createRequestMixins } from "@/mixins";
import { MessageApi } from "@/api";
import { ICommentItem } from "blog";
export default Vue.extend({
	components: {
		Message
	},
	mixins: [
		createRequestMixins({
			key: 'messages' as 'messages',
			defaultValue: {
				list: [] as ICommentItem[]
			}
		})
	],
	methods: {
		getMessages() {
			this.messagesLoading = true
			MessageApi.getMessages().then(v => {
				// console.log(v);
				this.messages.list = v?.data?.rows || []

			}).finally(() => {
				this.messagesLoading = false
			})
		}
	}
})
